<template>
    <!-- modal config: -->
    <!-- https://codepen.io/m2de/pen/JONpmj -->
    <!-- https://github.com/adamwathan/vue-tailwind-examples/blob/master/src/views/ModalExample.vue -->
    <portal to="modals">
        <transition
                @before-leave="cardLeaving = true"
                @after-leave="cardLeaving = false"
                enter-active-class="transition-all transition-fast ease-out-quad"
                leave-active-class="transition-all transition-medium ease-in-quad"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
                appear
            >
            <!-- make full screen for mobile -> md:flex md:justify-center min-h-screen -->
            <div v-if="showModal" class="fixed z-50 pin overflow-auto flex justify-center bg-gray-opacity-40" @click.self="close">
                <transition
                    @before-leave="cardLeaving = true"
                    @after-leave="cardLeaving = false"
                    enter-active-class="transition-all transition-fast ease-out-quad"
                    leave-active-class="transition-all transition-medium ease-in-quad"
                    enter-class="opacity-0 scale-70"
                    enter-to-class="opacity-100 scale-100"
                    leave-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-70"
                    appear
                >
                    <div class="flex items-center justify-center min-h-content max-w-3xl w-full my-0 md:my-10 z-50" @click.self="close" v-if="showContent">
                        <slot></slot>
                    </div>
                </transition>
            </div>
        </transition>
    </portal>
</template>

<script>
    export default {
        props: ['open'],
        data() {
            return {
                showModal: false,
                showBackdrop: false,
                showContent: false,
                backdropLeaving: false,
                cardLeaving: false,
            }
        },
        created() {
            const onEscape = (e) => {
                if (this.open && e.keyCode === 27) {
                    this.close()
                }
            }

            document.addEventListener('keydown', onEscape)

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', onEscape)
            })
        },
        watch: {
            open: {
                handler: function (newValue) {
                    if (newValue) {
                        this.show()
                    } else {
                        this.close()
                    }
                },
                immediate: true
            },
            leaving(newValue) {
                if (newValue === false) {
                    this.showModal = false
                    this.$emit('close')
                }
            }
        },
        computed: {
            leaving() {
                return this.backdropLeaving || this.cardLeaving
            }
        },
        methods: {
            show() {
                this.showModal = true
                this.showBackdrop = true
                this.showContent = true
            },
            close() {
                this.showBackdrop = false
                this.showContent = false
            },
        }
    }
</script>